import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import $ from 'jquery';

import * as classroomActions from '../../../../actions/classroom/classroomActions';

class EmptyClassroomPlaceholder extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.showAddPopup = this.showAddPopup.bind(this);
  }

  static propTypes = {
    emptyClassroom: PropTypes.bool,
    btnDefault: PropTypes.string,
    classroomActions: PropTypes.object
  };

  showAddPopup(e) {
    e.preventDefault();
    const { classroomActions } = this.props;
    classroomActions.setAddModalState(true);
    $('div.reveal.fade.in').css('top', '200px !important');
  }

  render() {
    const { emptyClassroom, btnDefault, enableCreateClass } = this.props;

    let emptyClassroomImg = emptyClassroom ? <img src={emptyClassroom} alt="presentation" /> : '';

    return (
      <div className="empty-classroom-placeholder">
        <div className="content">
          {emptyClassroomImg}
          <div className="text-title">{I18n.t('home.teacher.empty.title')}</div>
          <div className="text-info">
            {enableCreateClass
              ? I18n.t('home.teacher.empty.pressAddClass')
              : I18n.t('home.teacher.empty.info-createClassNotEnabled')}
          </div>
          {enableCreateClass ? (
            <input
              id="create-classroom-button"
              type="button"
              className="button secondary"
              value={I18n.t('home.teacher.empty.add')}
              onClick={this.showAddPopup}
              style={{ backgroundColor: btnDefault }}
            />
          ) : (
            undefined
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    emptyClassroom: state.theme.images.placeholders.emptyClassrooms,
    btnDefault: state.theme.colors.btnDefault,
    enableCreateClass: state.account.configuration.enableCreateClass
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmptyClassroomPlaceholder);
